import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { ChartType, ChartDataset, ChartOptions } from 'chart.js';
import { Task } from 'src/app/models/Task';

@Component({
  selector: 'app-radar-chart-worker-status',
  templateUrl: './radar-chart-worker-status.component.html',
  styleUrls: ['./radar-chart-worker-status.component.css']
})
export class RadarChartWorkerStatusComponent implements OnInit, OnChanges {

  @Input() dataset: Array<Task>;
  public radarChartOptions: ChartOptions = {
    responsive: true,
    plugins: {
      //to ne prikaže številk na grafu
      datalabels: {
          display: false,
      },
  },
    elements: {
      point: {
          radius: 2
      }
  }
  };
  public radarChartLabels: string[] = ['Odprto', 'Potrjeno', 'Preklicano', 'TO-DO', 'Se ne ureja'];

  public radarChartData: ChartDataset[] = [{ data: [], label: '' }];
  public radarChartType: ChartType = 'radar';

  public workerNames = [];
  public workerCodes = [];
  public mobile;
  constructor() { }

  ngOnInit() {
    if (window.screen.width < 500) { // 768px portrait
      this.mobile = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {

    if ('dataset' in changes) {
      this.radarChartData = [];
      this.drawBarChart();
    }
  }
  // events
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
  }

  drawBarChart(){

    if(this.dataset != undefined) {
      for (let i = 0; i < this.dataset.length; i++) {
        if (this.workerNames.length == 0 && this.workerCodes.length == 0 ) {
          this.workerNames.push(this.dataset[i].workerName);
          this.workerCodes.push(this.dataset[i].workerCode);
        } else {
          if (!this.workerCodes.includes(this.dataset[i].workerCode) && !this.workerNames.includes(this.dataset[i].workerName)){
            this.workerNames.push(this.dataset[i].workerName);
            this.workerCodes.push(this.dataset[i].workerCode);
          }
        }
      }
      let dataArray = [];
      let countCode1 = 0;
      let countCode3 = 0;
      let countCode6 = 0;
      let countCode7 = 0;
      let countCode35 = 0;
      for(let item of this.workerNames) {
          for(let i = 0; i < this.dataset.length; i++) {
            if(this.dataset[i].statusCode === '1' && this.dataset[i].workerName == item) {
              countCode1 ++;
            }
            if(this.dataset[i].statusCode === '3' && this.dataset[i].workerName == item) {
              countCode3 ++;
            }
            if(this.dataset[i].statusCode === '6' && this.dataset[i].workerName == item) {
              countCode6 ++;
            }
            if(this.dataset[i].statusCode === '7' && this.dataset[i].workerName == item) {
              countCode7 ++;
            }
            if(this.dataset[i].statusCode === '35' && this.dataset[i].workerName == item) {
              countCode35 ++;
            }
          }
          dataArray.push(countCode1);
          dataArray.push(countCode3);
          dataArray.push(countCode6);
          dataArray.push(countCode7);
          dataArray.push(countCode35);
           countCode1 = 0;
           countCode3 = 0;
           countCode6 = 0;
           countCode7 = 0;
           countCode35 = 0;


           if(dataArray != undefined) {
            this.radarChartData.push({ data: dataArray, label: item});
           }

        dataArray = [];

    }

    }

  }
}
